import React, { useEffect,useState } from "react";
import Form from "@rjsf/core";

import validator from "@rjsf/validator-ajv8";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { lengthAndValidCharactersInStringCheck, translateDateSelectActionButtons } from "../../../../utils/commonFunctions";
import useTranslatewrapper from "../../../../components/useTranslateWrapper";

const data = {};
const uischema = {
  comments: {
    "ui:autofocus": true,
    "ui:widget": "textarea",
    "ui:classNames":"comment-class"
  },
};


function SampleReceivedModal(props) {
  const {translate} = useTranslatewrapper();
  const navigate = useNavigate();
  const [modalDate, setModalDate] = React.useState(moment().local());
  const schema = {
    type: "object",
    properties: {
    
      comments: {
        type: "string",
        title: translate('comments'),
      },
    },
    required: ["SampleReceivedAtLabDate"],
  };
  useEffect(()=>{
    setDateValidated(validateFunction(modalDate))
  },[modalDate])
  
  const {
    handleClose,
    name,
    sampleData,
    action,
    setStateChange,
    handleLabSampleTestDone,
    buttonText,
    lastActionDate
  } = props;
  const event = new Date();

  const [formData, setFormData] = useState({SampleReceivedAtLabDate: event.toISOString().slice(0, 10)});
  const [open, setOpen] = React.useState(false);
  const [data1, setData1] = React.useState({});
  const [dateValidated, setDateValidated] = React.useState(false);
  const [globalErr, setGlobalErr] = React.useState([]);
  

  const dispatch = useDispatch();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const validateFunction =(e)=>{
    let newArr = [];
   
    if(sampleData){
      if(new Date(sampleData.sampleSentDate?.slice(0, 10)) > new Date(e.$d) ){
        newArr.push('Sample Received date cannot be before Sample sent date')
      }
      if(new Date(e.$d) > new Date()){
        newArr.push('Sample Received date cannot be greater than Current date')
      }
    }
    if (newArr.length > 0) {
      setGlobalErr(newArr)
      dispatchNotification("error", newArr);
      return false;
      
    } else {
      setGlobalErr([])
      return true
    }

  }
 
  const handleClickYes = async () => {
    handleLabSampleTestDone("", buttonText, data1);
    handleClickCloseDialog();
    handleClose(false);
  };
  const handleClickOpenDialog = (e) => {
    if (e) {
      
      setData1({
        SampleReceivedAtLabDate: modalDate,
        comments: e.formData?.comments
      });
      setOpen(true);
    }
  };

  const handleClickCloseDialog = () => {
    setOpen(false);
  };

  const validateComments =(e)=>{
    if(e.formData?.comments){
      let validationResult =  lengthAndValidCharactersInStringCheck(e.formData?.comments)
      if(!validationResult['status']){
        // arrErr.push("comments" +": "+ validationResult['message'])
        globalErr.push("comments" +": "+ validationResult['message'])
        setGlobalErr(globalErr);
        return false;
      }
      return true;
    }
    return true;
  }

  return (
    <div className="modalForm">
      <div>
         <Typography style={{ fontWeight: "400", fontFamily: "outfit", marginBottom: "1rem" }}>{translate('sampleReceivedAtLabDate')}</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs} localeText={translateDateSelectActionButtons(translate)}>
                <MobileDatePicker
                  value={modalDate}
                  disableFuture="true"
                  minDate={new Date(lastActionDate)}
                  label={translate('sampleReceivedAtLabDate')}
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} inputProps={{...params.inputProps, readOnly: true}}/>}
                  onChange={(date)=>{
                    
                    setModalDate(date.$d);
                  }}
                  className="input-date-picker"
                  sx={{ mb: "1", mt: "1",width: "97%" }}
                />
              </LocalizationProvider>
        </div>
      <Form
        schema={schema}
        validator={validator}
        uiSchema={uischema}
        formData={formData}
        onSubmit={(e) => {
          
          (dateValidated && validateComments(e)) ? handleClickOpenDialog(e) : dispatchNotification("error", globalErr);
          setGlobalErr([]);
        }}
        onChange={(e) => {
          setFormData(e.formData);
        }}
      >
        <div className="buttonSubmit">
          <Button type="submit" variant="contained">
            {translate('receive sample')}
          </Button>
        </div>
      </Form>
      <Dialog
        open={open}
        onClose={handleClickCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{translate('confirmationMsg')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {translate('confirmMarkSampleAsReceived')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseDialog} variant="contained">
            {translate('no')}
          </Button>
          <Button
            type="submit"
            variant="contained"
            onClick={handleClickYes}
            autoFocus
          >
            {translate('yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SampleReceivedModal;
